import React, { ReactNode } from 'react';
import classNames from 'classnames';
import SuggestedActionIcon from 'router/subrouters/DataRoom/pages/Dashboard/componenets/SuggestedActions/components/SuggestedActionIcon';
import { SuggestedActionType } from 'router/subrouters/DataRoom/models/Dashboard';
import { Button } from 'ncoded-component-library';
import ThreeDotsDropdown from 'components/ThreeDotsDropdown';

import './SuggestedActionItemWrapper.styles.scss';

type SuggestedActionItemWrapperProps = {
  className?: string;
  type?: SuggestedActionType;
  icon?: ReactNode;
  title: string;
  description: string;
  threeDotsOptions: any[];
  buttonDisabled?: boolean;
  buttonContent: string;
  onButtonClick: any;
};

const SuggestedActionItemWrapper: React.FC<SuggestedActionItemWrapperProps> = (
  props,
) => {
  const {
    children,
    className,
    type,
    icon,
    title,
    description,
    threeDotsOptions,
    buttonContent,
    onButtonClick,
    buttonDisabled = false,
  } = props;

  const classes = classNames('suggested-action-item-wrapper', className);

  return (
    <div className={classes}>
      <div className="suggested-action-item-wrapper__wrapper">
        {icon ?? (type && <SuggestedActionIcon type={type} />)}

        <div className="suggested-action-item-wrapper__content">
          <p>{title}</p>
          <p>{description}</p>
        </div>
      </div>

      <div className="suggested-action-item-wrapper__actions">
        <Button disabled={buttonDisabled} onClick={onButtonClick}>
          {buttonContent}
        </Button>
        <ThreeDotsDropdown
          renderAsPortal
          options={threeDotsOptions}
          portalClassName="suggested-action-item-wrapper__dropdown"
        />
      </div>

      {children}
    </div>
  );
};

export default SuggestedActionItemWrapper;
